"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const uiConstants_1 = require("../../../../constants/uiConstants");
const tagLabel_1 = __importDefault(require("../../../atoms/label/tagLabel"));
const TagLabelList = ({ textList, type = uiConstants_1.UI_TAG_PRIMARY, style = {} } = {}) => {
    return ((0, jsx_runtime_1.jsx)(material_1.List, { sx: { pt: 0.5, pr: 1, pb: 0, pl: globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP ? 0.5 : 2.5 }, style: style, children: textList.map(t => ((0, jsx_runtime_1.jsx)(tagLabel_1.default, { text: t, type: type }, t))) }));
};
exports.default = TagLabelList;
